var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsImport = function SvgIconsImport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.4 9.2a.6.6 0 0 1 .596.53L14 9.8v2.4a1.8 1.8 0 0 1-1.694 1.797L12.2 14H3.8a1.8 1.8 0 0 1-1.797-1.694L2 12.2V9.8a.6.6 0 0 1 1.196-.07l.004.07v2.4a.6.6 0 0 0 .53.596l.07.004h8.4a.6.6 0 0 0 .596-.53l.004-.07V9.8a.6.6 0 0 1 .6-.6zM8 2a.6.6 0 0 1 .596.53l.004.07v5.751l1.976-1.975a.6.6 0 0 1 .792-.05l.056.05a.6.6 0 0 1 .05.792l-.05.056-3 3a.605.605 0 0 1-.067.058l-.067.043-.067.032-.063.021-.09.018L8 10.4l-.045-.002-.075-.01-.067-.018-.067-.026-.058-.032-.056-.038-.056-.05-3-3a.6.6 0 0 1 .792-.898l.056.05L7.4 8.35V2.6A.6.6 0 0 1 8 2z"
  })));
};
export default SvgIconsImport;